import React from 'react';

const Footer = () => {
  const socialLinks = [
    { name: 'Instagram', url: '#', icon: '📷' },
    { name: 'Facebook', url: '#', icon: '👥' },
    { name: 'Twitter', url: '#', icon: '🐦' },
    { name: 'YouTube', url: '#', icon: '📺' }
  ];

  const quickLinks = [
    { name: 'About Simon', url: '#about' },
    { name: 'Show Details', url: '#show' },
    { name: 'Gallery', url: '#gallery' },
    { name: 'Tickets', url: '#tickets' },
    { name: 'Articles', url: '/articles' },
    { name: 'FAQ', url: '/faq' },
    { name: 'Contact', url: '#contact' }
  ];

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            {/* Logo and Description */}
            <div className="md:col-span-2">
              <h3 className="text-3xl font-bold mb-4">
                <span className="text-purple-400">SIMON</span> NOMIS
              </h3>
              <p className="text-gray-400 mb-6 max-w-md">
                Experience the impossible with Orlando's premier Master Magician and Illusionist. "Mental Hop Scotch" combines cutting-edge magic with masterful storytelling for an unforgettable evening.
              </p>
              <div className="flex space-x-4">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-purple-600 transition-colors duration-200"
                  >
                    <span className="text-lg">{social.icon}</span>
                  </a>
                ))}
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <a
                      href={link.url}
                      className="text-gray-400 hover:text-purple-400 transition-colors duration-200"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-xl font-semibold mb-4">Contact Info</h4>
              <div className="space-y-2 text-gray-400">
                <p>📍 Orlando, Florida</p>
                <p>📞 (407) 442-1933</p>
                <p>✉️ simon@simonnomismagic.com</p>
                <p>📷 @SIMONNOMISMAGIC</p>
                <p>🎭 Shows Saturdays at 7PM</p>

              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm">
              © 2025 Simon Nomis Live. All rights reserved.
            </div>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors duration-200">
                Privacy Policy
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors duration-200">
                Terms of Service
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-400 text-sm transition-colors duration-200">
                Accessibility
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;